<template>
  <div>
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">物流编号</span>
            <el-input
                v-model="listQuery.no"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">快递单号</span>
            <el-input
                v-model="listQuery.expressNo"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">物品名称</span>
            <el-input
                v-model="listQuery.goods"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box" v-if="!sendFlag">
            <span class="label">{{'发货/收货'}}</span>
            <el-select :filterable="true" v-model="listQuery.sendFlag" class="filter-item" placeholder="" @change="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in sendFlagOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box" v-if="!sourceType">
            <span class="label">物品类型</span>
            <el-select :filterable="true" v-model="listQuery.types" class="filter-item" placeholder="" @change="handleFilter" clearable multiple :size="t('table.btnSize')">
              <el-option
                v-for="item in typesOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <!-- <div class="filter-box" v-if="sendFlag">
            <span class="label">对应类型</span>
            <el-select :filterable="true" v-model="listQuery.sourceId" class="filter-item" placeholder="" @keyup.enter="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in sourceOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div> -->
          <template v-if="isShowDatePicker">
            <div class="filter-box">
              <span class="label">开始日期</span>
              <el-date-picker
                v-model="listQuery.startTime"
                type="date"
                placeholder=" "
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                @change="handleFilter"
                :size="t('table.btnSize')"
              >
              </el-date-picker>
            </div>
            <div class="filter-box">
              <span class="label">结束日期</span>
              <el-date-picker
                v-model="listQuery.endTime"
                type="date"
                placeholder=" "
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                @change="handleFilter"
                :size="t('table.btnSize')"
              >
              </el-date-picker>
            </div>
          </template>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <!-- <grid-layout
        v-model:layout="layouts"
        :col-num="12"
        :row-height="rowHeight"
        :is-draggable="false"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="false"
      >
        <grid-item
          v-for="(item,index ) in layouts"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          :minW="item.minW"
          :maxW="item.maxW"
          :minH="item.minH"
          :static="item.static"
          @resize="handleResizedEvent"
          @resized="handleResizedEvent">
          <template v-if="index === 0"> -->
            <TableList
              ref="tableListRef"
              v-loading="listLoading"
              :dataList="list"
              :total="total"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :isShowPagination="true"
              :canRefresh="false"
              :canChangeColumn="false"
              :canCommand="canCommand"
              @command-change="handleCommand"
            >
              <template v-slot:expressNo="scope">
                <el-link
                :href="`https://www.baidu.com/s?ie=UTF-8&wd=${scope.row.expressNo}`"
                target="_blank"
                type="primary"
                >
                  {{scope.row.expressNo}}
                </el-link>
              </template>
              <template v-slot:operation-action="scope">
                <CommandRender
                  :scopeRow='scope.row'
                  :codeList="btnList"
                  :permissionName="permissionName"
                  @command-change="handleCommand"
                />
              </template>
            </TableList>
            <!-- <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
          </template> -->
          <!-- <template v-if="index === 1">
            <div v-show="!isSubMenuCollapse">
              <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li v-for="item in tabList" :key="item.id" :class="{'active':activeTab===item.id}" @click="handleTabClick(item)">{{item.name}}</li>
                </ul>
              </div>
              <TraceInfo v-if="activeTab===3" ref="TraceInfo" :id="activeId" api="logistics"/>
              <BusinessInfo  v-if="activeTab===2" ref="TraceInfo" :id="activeId" api="logistics"/>
              <ChargeFee  v-if="activeTab===1" ref="ChargeFee" :id="activeId" api="logistics"/>
            </div>
          </template> -->
        <!-- </grid-item>
      </grid-layout> -->
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :dialogFormVisible="dialogFormVisible"
      :api="'logistics'"
      :sendFlag="sendFlag"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, ref, onMounted, watch } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { deleteById, getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { UsersModel } from '@/model/userModel'

import { ArrayRowsItem } from '@/model/Index'

import FormComponent from './Form.vue'
import TableList from '@/components/common/TableList.vue'
// import TraceInfo from '@/components/traceInfo/Index.vue'
// import BusinessInfo from './businessInfo/Index.vue'
// import ChargeFee from '@/views/financial/chargeFee/Index.vue'

import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'
// import { debounce } from 'lodash'
import mixin from '@/mixins/index'
import CommandRender from '@/components/common/CommandRender.vue'
import { useI18n } from 'vue-i18n'
export default defineComponent({
  components: {
    FormComponent,
    TableList,
    CommandRender
    // TraceInfo,
    // BusinessInfo,
    // ChargeFee
  },
  props: {
    sendFlag: { type: Number, required: false, default: 0 },
    TableName: { type: String, required: false, default: 'TABLE_DELIVERY_INFO' },
    permissionName: { type: String, required: false, default: 'DELIVERY_INFO' },
    sourceId: { type: Number, required: false, default: 0 },
    sourceType: { type: Number, required: false, default: 0 },
    canCommand: { type: Boolean, required: false, default: true },
    isShowDatePicker: { type: Boolean, required: false, default: true }
  },
  setup(props) {
    const { t } = useI18n()
    const tableListRef = ref({})
    const dataMap = reactive({
      sendFlag: props.sendFlag,
      sourceId: props.sourceId,
      sourceType: props.sourceType,
      TableName: TableName[props.TableName],
      permissionName: permissionName[props.permissionName],
      isShowDatePicker: props.isShowDatePicker,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        no: undefined,
        expressNo: undefined,
        goods: undefined,
        sendFlag: undefined,
        types: [],
        startTime: '',
        endTime: '',
        sourceId: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      typesOption: [],
      sendFlagOption: [],
      sourceOption: [],
      btnList: [],
      pageSizes,
      tabList: [
        // { name: '业务信息', id: 2 },
        // { name: '收款明细', id: 1 },
        { name: '跟踪信息', id: 3 }
      ],
      newHpx: 0,
      activeTab: 3,

      handleCommand(command: string, val?: any) {
        console.log(command, 'command')
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        const types = dataMap.listQuery.types as any
        const params = {
          ...dataMap.listQuery,
          types: types && types.join()
        }
        if (props.sendFlag) {
          Object.assign(params, { sendFlag: props.sendFlag })
        }
        if (props.sourceId) {
          Object.assign(params, { sourceId: props.sourceId })
        }
        if (props.sourceType) {
          Object.assign(params, { types: props.sourceType })
        }
        getPageList('logistics', params).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          expressNo: undefined,
          goods: undefined,
          sendFlag: undefined,
          types: [],
          startTime: '',
          endTime: '',
          sourceId: undefined,
          ...pageVo
        }
        if (props.isShowDatePicker) {
          dataMap.listQuery.startTime = defaultDate[0]
          dataMap.listQuery.endTime = defaultDate[1]
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        if (!props.isShowDatePicker) {
          dataMap.getList()
          return
        }
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.dialogFormVisible = true
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('logistics', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/LogisticsType').then((res: any) => {
          dataMap.typesOption = res || []
        })
        getUrlList('dropdown/LogisticsSendType').then((res: any) => {
          dataMap.sendFlagOption = res || []
        })
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      }
    })
    const { mixinData } = mixin(dataMap)

    watch(() => props.sourceId, () => {
      dataMap.getList()
    })

    onMounted(() => {
      mixinData.initHeight()
      dataMap.btnList = [
        {
          pkey: `${dataMap.permissionName}_EDIT`,
          name: '编辑',
          command: 'edit'
        },
        // {
        //   pkey: `${dataMap.permissionName}_LIST`,
        //   name: '物流信息',
        //   target: '_blank',
        //   href: (row: any) => {
        //     return `https://www.baidu.com/s?ie=UTF-8&wd=${row.expressNo}`
        //   }
        // },
        {
          pkey: `${dataMap.permissionName}_DELETE`,
          name: '删除',
          command: 'delete',
          type: 'danger'
        }
      ]
      if (props.isShowDatePicker) {
        dataMap.listQuery.startTime = defaultDate[0]
        dataMap.listQuery.endTime = defaultDate[1]
      }

      dataMap.getList()
      dataMap.getDropdownList()
      // dataMap.getTitleOptionRemote('')
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss">

</style>
